import { PlanningSessionProvider } from '../../contexts/PlanningSessionContext';
import { Outlet } from 'react-router-dom';
import { Navigation } from './Navigation';

export const Layout: React.FC = () => {
  return (
    <PlanningSessionProvider>
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <main className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </PlanningSessionProvider>
  );
};
